import {useContext} from 'react';
import AppContext from 'library/AppContext';

function useConfirm(){

    const context = useContext(AppContext);

    function setConfirm(message, callback, ok, cancel, cancelCallback){

        context.confirmModal(message, callback, ok, cancel, cancelCallback);
    }

    return setConfirm;
}

export default useConfirm;
